export const POSITIONALMEDIA_AUTOSTARTED = 'PositionalMedia_AutoStarted'
export const POSITIONALMEDIA_STARTED = 'PositionalMedia_Started'
export const POSITIONALMEDIA_PAUSED = 'PositionalMedia_Paused'
export const POSITIONALMEDIA_COMPLETED = 'PositionalMedia_Completed'

export const DESCRIPTION_SCROLLED = 'Description_Scrolled'
export const EXPERIENCENAME_CLICKED = 'ExperienceName_Clicked'
export const EXPERIENCELIST_VIEWED = 'ExperienceList_Viewed'
export const EXPERIENCELIST_EXPERIENCE_SELECTED = 'ExperienceList_Experience_Selected'
export const EXPERIENCELIST_CLOSED = 'ExperienceList_Closed'

export const SCENE_PANS = 'Scene_Pans'
export const PANORAMA_ZOOM = 'Panorama_Zoom'

export const HOTSPOT_IN_SCENE = 'HotSpot_InScene'
export const HOTSPOT_PANNED = 'HotSpot_Panned'
export const HOTSPOT_HOVERSTATE = 'HotSpot_HoverState'
export const HOTSPOT_MODALOPENED = 'HotSpot_ModalOpened'
export const HOTSPOT_VIDEOSTARTED = 'Hotspot_VideoStarted'
export const HOTSPOT_VIDEOPAUSED = 'Hotspot_VideoPaused'
export const HOTSPOT_VIDEOCOMPLETED = 'Hotspot_VideoCompleted'
export const HOTSPOT_EXITED = 'HotSpot_Exited'

export const TRIGGER_IN_SCENE = 'Trigger_InScene'
export const TRIGGER_HOVERSTATE = 'Trigger_HoverState'
export const TRIGGER_OPENED = 'Trigger_Opened'
export const TRIGGER_EXITED = 'Trigger_Exited'
export const TRIGGER_STARTED = 'Trigger_Started'
export const TRIGGER_PAUSED = 'Trigger_Paused'
export const TRIGGER_PANNED = 'Trigger_Panned'
export const TRIGGER_COMPLETED = 'Trigger_Completed'

export const ELEMENT_COUNTER_SHOWN = 'ElementCounter_Shown'
export const ELEMENT_COUNTER_LIST_VIEWED = 'ElementCounter_ListViewed'
export const ELEMENT_COUNTER_TAP_TO_VIEW_ELEMENT = 'ElementCounter_TaptoViewElement'

export const NEXT_BUTTON_CLICKED = 'NextButton_Clicked'
export const INFO_ICON_CLICKED = 'InfoIcon_Clicked'
export const SOUND_BUTTON_MUTE = 'SoundButton_Mute'
export const SOUND_BUTTON_UNMUTE = 'SoundButton_Unmute'

export const USER_REGISTRATION_OPT_IN_PROMPT_SHOWN = 'User_Registration_Opt_In_Prompt_Shown'
export const USER_REGISTRATION_OPT_IN_PROMPT_BUTTON_CLICK = 'User_Registration_Opt_In_Prompt_Button_Click'

export const DEVICE_ORIENTATION_CHANGED = 'Device_Orientation_Changed'

export const EXPERIENCE_RESTARTED = 'Experience_Restarted'
